import React from "react";

const DatePickerArrowRight = ({ className }) => (
  <svg
    width="9"
    className={className}
    height="14"
    viewBox="0 0 9 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 13l6-6-6-6"
      fillRule="nonzero"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
  </svg>
);

export default DatePickerArrowRight;
